import axios from "axios";
import {config} from "../constants";
import authHeader from "./auth-header";

class DashboardService {

    getDashboardData() {
        return axios.get(config.API_URL + "dashboard", {headers: authHeader()});
    }

    getDashboardServiceData() {
        return axios.get(config.API_URL + "dashboard/service-data", {headers: authHeader()});
    }

    handleMailIfServiceIsDown(serviceName){
        return axios.put(config.API_URL + "dashboard/service-mail/" + serviceName,{}, {headers: authHeader()})
    }

}

export default new DashboardService();
